export default __webpack_public_path__ + "images/0ffe52da5f73252e600ad0395f17e6a5.png";